import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
    selector: 'app-image-options-dialog',
    templateUrl: './image-options-dialog.component.html'
})
export class ImageOptionsDialogComponent {

    constructor(
        private dialogRef: MatDialogRef<ImageOptionsDialogComponent>
    ) { }

    selectOption(option: string) {
        this.dialogRef.close(option); // THIS closes dialog
    }
}
